export default function Tabs({ tabs, active, onChange, underline = false, scrollable = false }) {
  if (underline) {
    return (
      <div className="tab-bar">
        {tabs.map((t, i) => <button key={i} onClick={() => onChange(i)} className={`tab-btn ${active === i ? "active" : ""}`}>{typeof t === "object" ? t.label : t}</button>)}
      </div>
    );
  }

  const containerClass = scrollable 
    ? "flex gap-1 bg-slate-100 dark:bg-slate-800 rounded-xl p-1 mb-4 overflow-x-auto max-w-full w-fit custom-tabs-scroll"
    : "flex gap-1 bg-slate-100 dark:bg-slate-800 rounded-xl p-1 mb-4 flex-wrap w-fit";

  return (
    <div className={containerClass}>
      {scrollable && (
        <style>{`
          .custom-tabs-scroll::-webkit-scrollbar { height: 4px; }
          .custom-tabs-scroll::-webkit-scrollbar-track { background: transparent; }
          .custom-tabs-scroll::-webkit-scrollbar-thumb { background: rgba(156, 163, 175, 0.5); border-radius: 4px; }
        `}</style>
      )}
      {tabs.map((t, i) => (
        <button key={i} onClick={() => onChange(i)}
          className={`px-4 py-1.5 rounded-lg text-xs font-semibold transition-all cursor-pointer border-0 whitespace-nowrap ${active === i ? "bg-white dark:bg-slate-900 text-ink dark:text-white shadow-card dark:shadow-none" : "text-muted bg-transparent hover:text-slate-700 dark:hover:text-slate-200"}`}>
          {typeof t === "object" ? t.label : t}
        </button>
      ))}
    </div>
  );
}
